'use strict'

const withActions = func =>
    function (...args) {
        return func(this, ...args)
    }

module.exports.withActions = withActions